import { EntitiesStore } from './entities-store.abstract';

import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

export interface INewsPhoto {
  src: string;
  alt: any;
  title: string;
}

export interface IMemberNewsResult {
  title: string;
  url: string;
  photo: INewsPhoto;

}

export interface IMemberNews {
  results: Array<IMemberNewsResult>;
  pager: {
    count: number,
    pages: number,
    items_per_page: number,
    current_page: number,
    next_page: number
  }
}




export class MemberNewsStore extends EntitiesStore<IMemberNewsResult> {

  /**
   * Input for filter by category.
   *
   * @type {string}
   * @memberof MemberNewsStore
   */
  public filter_by_category: string;

  /**
   *The athlete id for make the request.
   *
   * @type {string}
   * @memberof MemberNewsStore
   */
  member_id: string;
  constructor(http: HttpClient) {
    super('null', http);
  }

  /**
   *
   * {@inheritdoc}
   * @returns {Observable<any>}
   * @memberof AthletePhotosStore
   */
  getRequest(params: any, request_more: boolean = false): Observable<any> {
    this.loadingRef = true;
    const is_continental = /^-?\d+$/.test(this.member_id);
    const url = is_continental ? environment.news_api.continental_association_teaser : environment.news_api.member_association_teaser;
    let page = (this.pagination && this.pagination['pages']) ?
      (this.pagination['next_page'] !== 0 ? this.pagination['next_page'] : this.pagination['page']) : 0;
    if (request_more === false) {
      page = 0;
    }
    params = { page: page };
    if (this.filter_by_category) {
      Object.assign(params, { category: this.filter_by_category.toLowerCase() });
    }
    return this.http.get(environment.drupal_api + url.replace('replace_id', this.member_id), {
      params: params
    })
      .pipe(
        catchError((e) => of([])),
        tap((next: IMemberNews) => {
          if (request_more === false) {
            this.dataStream.next(next);
            this.data = next.results;
          } else {
            this.data = Array.from(this.data.concat(next.results).reduce((f, s) =>
              f.set((s as IMemberNewsResult).title, s), new Map()
            ).values());

            this.dataStream.next(this.data);
          }
          this.pagination = {
            count: next.pager.count,
            pages: next.pager.pages,
            items_per_page: next.pager.items_per_page,
            current_page: next.pager.current_page,
            next_page: next.pager.next_page
          } as any;
          this.loadingRef = false;
          this.requestMore = false;
        }));
  }



}
